import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { getCurrentUser, resendVerificationEmail, reloadUser, logoutEmployer } from '../services/authService';
import { functions } from '../config/firebase';

function VerifyEmailPage() {
  const navigate = useNavigate();
  const [resendStatus, setResendStatus] = useState('');
  const [checkStatus, setCheckStatus] = useState('');
  const [resending, setResending] = useState(false);
  const [checking, setChecking] = useState(false);

  // If not signed in at all, redirect to login
  if (!getCurrentUser()) {
    return <Navigate to="/" replace />;
  }

  const handleCheckVerified = async () => {
    setChecking(true);
    setCheckStatus('');
    try {
      await reloadUser();
      const confirmEmailVerification = httpsCallable(functions, 'confirmEmailVerification');
      await confirmEmailVerification();
      navigate('/dashboard');
    } catch (err) {
      if (err.code === 'functions/failed-precondition') {
        setCheckStatus('Email not yet verified. Please click the link in your inbox.');
      } else {
        setCheckStatus('Unable to check status. Please try again.');
      }
    } finally {
      setChecking(false);
    }
  };

  const handleResend = async () => {
    setResending(true);
    setResendStatus('');
    try {
      await resendVerificationEmail();
      setResendStatus('Verification email sent. Check your inbox.');
    } catch (err) {
      setResendStatus('Failed to resend. Please try again shortly.');
    } finally {
      setResending(false);
    }
  };

  const handleSignOut = async () => {
    await logoutEmployer();
    navigate('/');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6' }}>
      <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', width: '100%', maxWidth: '480px', textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '1rem' }}>📧</div>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '0.75rem' }}>Verify your email</h1>
        <p style={{ color: '#374151', marginBottom: '0.5rem', fontSize: '15px' }}>
          We've sent a verification link to your email address.
        </p>
        <p style={{ color: '#6b7280', marginBottom: '2rem', fontSize: '14px' }}>
          Click the link in your inbox to activate your account, then return here and click the button below.
        </p>

        {checkStatus && (
          <div style={{
            backgroundColor: checkStatus.includes('not') || checkStatus.includes('Unable') ? '#fee2e2' : '#d1fae5',
            color: checkStatus.includes('not') || checkStatus.includes('Unable') ? '#991b1b' : '#065f46',
            padding: '0.75rem',
            borderRadius: '4px',
            marginBottom: '1rem',
            fontSize: '14px',
          }}>
            {checkStatus}
          </div>
        )}

        <button
          onClick={handleCheckVerified}
          disabled={checking}
          style={{ width: '100%', backgroundColor: '#2563eb', color: 'white', padding: '0.75rem', borderRadius: '4px', border: 'none', fontSize: '16px', fontWeight: '500', cursor: checking ? 'not-allowed' : 'pointer', opacity: checking ? 0.5 : 1, marginBottom: '0.75rem' }}
        >
          {checking ? 'Checking...' : "I've verified my email — continue"}
        </button>

        {resendStatus && (
          <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '0.75rem' }}>{resendStatus}</p>
        )}

        <button
          onClick={handleResend}
          disabled={resending}
          style={{ width: '100%', backgroundColor: 'transparent', color: '#2563eb', padding: '0.75rem', borderRadius: '4px', border: '1px solid #2563eb', fontSize: '15px', cursor: resending ? 'not-allowed' : 'pointer', opacity: resending ? 0.5 : 1, marginBottom: '1.5rem' }}
        >
          {resending ? 'Sending...' : 'Resend verification email'}
        </button>

        <button
          onClick={handleSignOut}
          style={{ background: 'none', border: 'none', color: '#9ca3af', fontSize: '14px', cursor: 'pointer' }}
        >
          Sign out and use a different account
        </button>
      </div>
    </div>
  );
}

export default VerifyEmailPage;
